module.exports = __webpack_public_path__ + "static/media/zonebuilt-icon.27d3e1cd.svg";